.body {
  display: grid;
  gap: 26px;
}

.pressReleaseRoot {
  @container press-release-root (min-width:1024px) {
    grid-template-columns: auto 1fr;
    gap: 32px;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    grid-template-columns: auto 1fr;
    gap: 32px;
  }
}
